import { INVENTORY_CHECKLIST } from "./type";

const initalState = {
  inventoryData: [],
};

const inventoryReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case INVENTORY_CHECKLIST:
      return {
        ...state,
        inventoryData: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default inventoryReducer;
